import { ref } from "vue";

const visible = ref(false);
const documentId = ref(null);
const projectId = ref(null);
// Optional partial data already in memory (e.g. from a card) — lets the panel
// paint instantly while it fetches the full record (which adds source/webViewLink).
const seedDocument = ref(null);
const seedProject = ref(null);

export function useDocumentDetails() {
  function open({ documentId: docId, projectId: projId, document = null, project = null }) {
    documentId.value = docId;
    projectId.value = projId;
    seedDocument.value = document;
    seedProject.value = project;
    visible.value = true;
  }
  function close() {
    visible.value = false;
  }
  return { visible, documentId, projectId, seedDocument, seedProject, open, close };
}
